(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-quick-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('bb-quick-chat');
    if (!root || root.dataset.ready) return;
    const panel = root.querySelector('dialog');
    if (typeof panel.show !== 'function') return;
    root.dataset.ready = 'true';
    const launcher = root.querySelector('.bb-chat__launcher');
    const home = root.querySelector('[data-chat-home]');
    const answer = root.querySelector('[data-chat-answer]');
    const question = root.querySelector('[data-chat-question]');
    const content = root.querySelector('[data-chat-content]');
    const body = root.querySelector('.bb-chat__body');
    let lastTopic = null;
    const html = document.documentElement;
    const blocked = () => ['bb-shopify-privacy-pending', 'bb-navigation-open', 'bb-welcome-active'].some(name => html.classList.contains(name)) || (html.getAttribute('data-bb-popup-state') || '').startsWith('visible-');
    const close = (restore = true) => {
      if (!panel.open) return;
      panel.close();
      launcher.setAttribute('aria-expanded', 'false');
      if (restore) launcher.focus();
    };
    launcher.addEventListener('click', () => {
      if (panel.open) { close(); return; }
      if (blocked()) return;
      panel.show();
      launcher.setAttribute('aria-expanded', 'true');
      panel.querySelector('#bb-chat-title').focus({ preventScroll: true });
    });
    root.querySelector('.bb-chat__close').addEventListener('click', () => close());
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });
    panel.addEventListener('close', () => launcher.setAttribute('aria-expanded', 'false'));
    root.querySelectorAll('[data-chat-topic]').forEach(button => {
      button.addEventListener('click', () => {
        const template = root.querySelector('[data-chat-template="' + button.dataset.chatTopic + '"]');
        if (!template) return;
        lastTopic = button;
        question.textContent = button.textContent.replace('›', '').trim();
        content.replaceChildren(template.content.cloneNode(true));
        home.hidden = true;
        answer.hidden = false;
        body.scrollTop = 0;
        question.focus({ preventScroll: true });
      });
    });
    root.querySelector('.bb-chat__back').addEventListener('click', () => {
      answer.hidden = true;
      home.hidden = false;
      content.replaceChildren();
      body.scrollTop = 0;
      const target = lastTopic && lastTopic.offsetParent !== null ? lastTopic : home.querySelector('button');
      if (target) target.focus({ preventScroll: true });
    });
    panel.addEventListener('click', event => {
      if (event.target.closest('a')) close(false);
    });
    const narrow = window.matchMedia('(max-width: 989px)');
    let compactQueued = false;
    const compact = () => {
      compactQueued = false;
      launcher.classList.toggle('is-compact', narrow.matches && window.scrollY > 160 && !panel.open);
    };
    const queueCompact = () => { if (!compactQueued) { compactQueued = true; requestAnimationFrame(compact); } };
    window.addEventListener('scroll', queueCompact, { passive: true });
    if (narrow.addEventListener) narrow.addEventListener('change', compact); else if (narrow.addListener) narrow.addListener(compact);
    launcher.addEventListener('click', () => setTimeout(compact, 0));
    panel.addEventListener('close', compact);
    compact();
    const typingField = el => Boolean(el && el.matches && !root.contains(el) && el.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="hidden"]), textarea, select'));
    document.addEventListener('focusin', event => { if (typingField(event.target)) html.classList.add('bb-form-typing'); });
    document.addEventListener('focusout', () => { setTimeout(() => { if (!typingField(document.activeElement)) html.classList.remove('bb-form-typing'); }, 0); });
    const observer = new MutationObserver(() => { if (blocked()) close(false); });
    observer.observe(html, { attributes: true, attributeFilter: ['class', 'data-bb-popup-state'] });
    root.hidden = false;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-ux-monitor"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('bb-ux-monitor');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const mode = root.dataset.mode;
  if (mode === 'off' || window.Shopify?.designMode) return;
  const preview = ['unpublished', 'development', 'demo'].includes(window.Shopify?.theme?.role);
  const test = mode === 'test' && preview && new URLSearchParams(location.search).get('bb_ux_test') === '1';
  if (mode === 'test' && !test) return;
  if (!test && mode !== 'pixels') return;
  const status = root.querySelector('[data-ux-status]');
  let active = false, controller, observer, performanceObserver, timer, epoch = 0;
  let records = [], counters = new Map(), forms = new Map(), steps = new Set(), sent = 0;
  const topics = new Set(['quote','service','product','spare','minorder','account','services','area','contact']);
  const categories = new Map([
    ['/','home'],['/pages/contact','contact'],['/pages/configuratore-impianto','configurator'],
    ['/pages/area-clienti','customer_area'],['/collections/shop-online','catalog'],['/cart','cart'],
    ['/pages/climatizzazione','service'],['/pages/riscaldamento','service'],['/pages/impianti-idraulici','service'],
    ['/pages/settore-termale','service'],['/pages/impianti-industriali','service'],['/pages/antincendio','service'],
    ['/pages/bagni-chiavi-in-mano','service'],['/pages/energie-rinnovabili','service'],['/pages/manutenzione','service']
  ]);
  const category = pathname => categories.get(pathname.replace(/\/$/, '') || '/') || (pathname.startsWith('/products/') ? 'product' : pathname.startsWith('/collections/') ? 'catalog' : 'other');
  const page = category(location.pathname);
  const device = innerWidth < 750 ? 'mobile' : innerWidth < 1100 ? 'tablet' : 'desktop';
  const allowed = () => {
    try {
      const p = window.Shopify?.customerPrivacy;
      return p?.currentVisitorConsent().analytics === 'yes' && p.analyticsProcessingAllowed() === true;
    } catch { return false; }
  };
  const render = () => {
    if (!test) return;
    root.querySelector('[data-ux-count]').textContent = String(records.length);
    root.querySelector('[data-ux-events]').textContent = records.slice(-8).map(x => JSON.stringify(x)).join('\n');
    status.textContent = active ? status.dataset.running : status.dataset.waiting;
  };
  const emit = (event, target = '', value = '') => {
    if (!active) return;
    if (!test && !allowed()) { stop(); return; }
    const key = event + ':' + target + ':' + value;
    const count = counters.get(key) || 0;
    if (sent >= 150 || count >= 10) return;
    counters.set(key, count + 1); sent++;
    const data = {schema:1, theme:'v12', environment:test ? 'test' : preview ? 'preview' : 'live', page, device, event, target, value};
    if (test) { records.push(data); render(); return; }
    try {
      const result = window.Shopify?.analytics?.publish('bellucco:ux', data);
      if (result?.catch) result.catch(() => {});
    } catch {}
  };
  const formName = form => {
    if (!form) return null;
    if (form.matches('#bb-preventivo-form')) return 'quote';
    if (form.matches('[data-bb-contact]')) return 'contact';
    if (form.matches('#bb-product-request-form')) return 'product_request';
    if (form.closest('.bcfg')) return 'configurator';
    return null;
  };
  const startForm = form => {
    const name = formName(form);
    if (!name) return;
    if (!forms.has(form)) { forms.set(form, {name,done:false}); emit('form_start',name); }
    else if (forms.get(form).done) { forms.set(form, {name,done:false}); emit('form_start',name); }
  };
  const scan = () => {
    if (!active) return;
    document.querySelectorAll('.bcfg-step.is-active').forEach(el => {
      const step = el.dataset.step;
      if (/^[1-5]$/.test(step) && !steps.has(step)) { steps.add(step); emit('config_step','configurator',step); }
    });
    for (const [form, state] of forms) {
      const container = form.closest('.bcfg') || form;
      const success = container.querySelector('[data-bb-contact-status].is-success:not([hidden]),.bb-form-status.is-success:not([hidden]),.bpr-status.is-success:not([hidden]),.bcfg-status.ok:not([hidden])');
      const failure = container.querySelector('[data-bb-contact-status].is-error:not([hidden]),.bb-form-status.is-error:not([hidden]),.bpr-status.is-error:not([hidden]),.bcfg-status.err:not([hidden])');
      if (!success) state.staleSuccess = false;
      if (success && state.pending && !state.staleSuccess && !state.done) { state.done = true; state.pending = false; emit('form_success',state.name); }
      if (failure && state.pending && !state.error) { state.error = true; state.pending = false; emit('form_error',state.name); }
      if (!failure) state.error = false;
    }
  };
  function stop() {
    active = false; epoch++;
    controller?.abort(); observer?.disconnect(); performanceObserver?.disconnect(); clearTimeout(timer);
    records = []; counters.clear(); forms.clear(); steps.clear(); sent = 0;
    render();
  }
  function start() {
    if (active || (!test && !allowed())) return;
    active = true; epoch++; controller = new AbortController();
    const signal = controller.signal;
    emit('page_view');
    document.addEventListener('click', e => {
      const el = e.target.closest?.('a,button,summary');
      if (!el || root.contains(el)) return;
      if (el.matches('[data-chat-topic]') && topics.has(el.dataset.chatTopic)) emit('chat_topic',el.dataset.chatTopic);
      else if (el.matches('.bb-chat__launcher')) emit('chat_open','chat');
      else if (el.closest('header-drawer') && el.matches('summary')) emit('menu_toggle','mobile_menu');
      if (el.tagName !== 'A') return;
      try {
        const url = new URL(el.href, location.origin);
        let dest = url.protocol === 'tel:' ? 'phone' : url.protocol === 'mailto:' ? 'email' : url.hostname === 'wa.me' ? 'whatsapp' : '';
        if (url.origin === location.origin) dest = url.hash === '#preventivo' ? 'quote' : category(url.pathname);
        if (dest && dest !== 'other') emit('link_click',dest,el.closest('#bb-quick-chat') ? 'chat' : el.closest('header,#header-group') ? 'header' : el.closest('footer,.bb-footer') ? 'footer' : 'content');
      } catch {}
    }, {signal, passive:true});
    document.addEventListener('input', e => startForm(e.target.closest?.('form')), {signal, passive:true});
    document.addEventListener('invalid', e => {
      const form = e.target.closest?.('form'); const name = formName(form);
      if (name) {
        startForm(form);
        const state = forms.get(form), now = performance.now();
        if (state.invalidAt === undefined || now - state.invalidAt > 250) { state.invalidAt = now; emit('form_invalid',name); }
      }
    }, {signal, capture:true});
    document.addEventListener('submit', e => {
      const name = formName(e.target);
      if (name) {
        startForm(e.target);
        if (name === 'configurator' && !e.target.querySelector('.bcfg-step.is-active[data-step="5"]')) return;
        const state = forms.get(e.target);
        state.pending = true;
        state.staleSuccess = Boolean(e.target.querySelector('.is-success:not([hidden])'));
        emit('form_submit_attempt',name);
      }
    }, {signal, capture:true});
    let scrollTimer;
    document.addEventListener('scroll', () => {
      if (scrollTimer) return;
      scrollTimer = setTimeout(() => {
        scrollTimer = null;
        if (!active) return;
        const height = document.documentElement.scrollHeight - innerHeight;
        if (height <= 0) return;
        const percentage = 100 * scrollY / height;
        [25,50,75,90].forEach(n => { const key='scroll_'+n; if (percentage >= n && !steps.has(key)) { steps.add(key); emit('scroll_depth','page',String(n)); } });
      }, 300);
    }, {signal, passive:true});
    signal.addEventListener('abort', () => clearTimeout(scrollTimer), {once:true});
    window.addEventListener('error', e => {
      if (e instanceof ErrorEvent) emit('script_error','page');
    }, {signal});
    window.addEventListener('pagehide', () => {
      for (const s of forms.values()) if (!s.done) emit('form_exit_without_success',s.name);
      if (!test) stop();
    }, {signal});
    observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 100); });
    observer.observe(document.getElementById('MainContent') || document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});
    try {
      const myEpoch = epoch;
      performanceObserver = new PerformanceObserver(list => {
        if (!active || epoch !== myEpoch) return;
        for (const entry of list.getEntries()) if (entry.duration >= 200) emit('slow_interaction','page',entry.duration >= 500 ? 'over_500ms' : '200_500ms');
      });
      performanceObserver.observe({type:'event',durationThreshold:200,buffered:false});
    } catch {}
    scan(); render();
  }
  if (test) {
    root.hidden = false;
    root.querySelector('[data-ux-start]').addEventListener('click', start);
    root.querySelector('[data-ux-stop]').addEventListener('click', stop);
    root.querySelector('[data-ux-export]').addEventListener('click', () => {
      const data = {description:'Local test only; not customer statistics',events:records};
      const url = URL.createObjectURL(new Blob([JSON.stringify(data,null,2)], {type:'application/json'}));
      const a = document.createElement('a'); a.href=url; a.download='bellucco-v12-test-ux.json'; a.click(); setTimeout(() => URL.revokeObjectURL(url),1000);
    });
  } else {
    const sync = () => allowed() ? start() : stop();
    document.addEventListener('visitorConsentCollected',sync);
    document.addEventListener('shopifyCustomerPrivacyApiLoaded',sync);
    window.addEventListener('pageshow',sync);
    if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) sync(); });
    sync();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
